module.exports = __webpack_public_path__ + "img/briefcase.edb3f9ef.svg";